package com.arena_web.data.repository

import com.arena_web.data.api.FollowApi
import com.arena_web.data.dto.FollowCountsDto
import com.arena_web.data.dto.FollowRelationDto
import com.arena_web.data.dto.FollowUserPageDto
import com.arena_web.domain.repositories.FollowRepository

class FollowRepositoryImpl(private val followApi: FollowApi) : FollowRepository {

    override suspend fun followUser(userId: String): Result<Unit> =
        apiCallUnit { followApi.followUser(userId) }

    override suspend fun unfollowUser(userId: String): Result<Unit> =
        apiCallUnit { followApi.unfollowUser(userId) }

    override suspend fun removeFollower(userId: String): Result<Unit> =
        apiCallUnit { followApi.removeFollower(userId) }

    override suspend fun getMyFollowers(params: Map<String, String>): Result<FollowUserPageDto> =
        apiCall { followApi.getMyFollowers(params) }

    override suspend fun getMyFollowing(params: Map<String, String>): Result<FollowUserPageDto> =
        apiCall { followApi.getMyFollowing(params) }

    override suspend fun getFollowers(
        userId: String,
        params: Map<String, String>,
    ): Result<FollowUserPageDto> =
        apiCall { followApi.getFollowers(userId, params) }

    override suspend fun getFollowing(
        userId: String,
        params: Map<String, String>,
    ): Result<FollowUserPageDto> =
        apiCall { followApi.getFollowing(userId, params) }

    override suspend fun getCounts(userId: String): Result<FollowCountsDto> =
        apiCall { followApi.getCounts(userId) }

    override suspend fun getRelation(userId: String): Result<FollowRelationDto> =
        apiCall { followApi.getRelation(userId) }
}
